import { ErrorHandler, inject, provideAppInitializer } from '@angular/core';

import { ErrorHandlerService } from './error-handler/error-handler.service';
import { ErrorTrackingService } from './error-tracking/error-tracking.service';

function initialiseTrackJS(trackJsService: ErrorTrackingService) {
  return () => trackJsService.initialise();
}

export function provideRmaErrorHandler() {
  return [
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideAppInitializer(() => {
      const initializerFn = initialiseTrackJS(inject(ErrorTrackingService));
      return initializerFn();
    }),
  ];
}
